import { render, staticRenderFns } from "./questionForm.vue?vue&type=template&id=80f42daa&"
import script from "./questionForm.vue?vue&type=script&lang=js&"
export * from "./questionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports